import FeatureFlagUtil from '@/utilities/feature-flag-util';
import RouteNames from '../constants/route-names';
import StepUtilites from '../utilities/step-utilities';

const validateFeatureFlagRoute = from => {
  if (FeatureFlagUtil.isServicesEnabled()) {
    return null;
  }

  const servicesStepIndex = StepUtilites.getStepIndexByRouteName(RouteNames.AppointmentServices);
  const nextStepName = StepUtilites.getStepByIndex(servicesStepIndex + 1);
  const prevStepName = StepUtilites.getStepByIndex(servicesStepIndex - 1);

  // moving back in process
  if (from.name === nextStepName) {
    return prevStepName;
  }

  // moving forward in process
  if (from.name === prevStepName) {
    return nextStepName;
  }

  return null;
};

export default { validateFeatureFlagRoute };
